import type { AxiosError } from 'axios';
import type { ResponseError } from '@gov-nx/api/errors/errors.types';
import { usePoMutation } from '@gov-nx/api/hooks/usePoMutation';
import { confirmAuthCode } from '@gov-nx/api/queries/authQuery';

interface ConfirmAuthCodeProps {
	onSuccess?: (data: Awaited<ReturnType<typeof confirmAuthCode>>) => void;
	onError?: (error: AxiosError<ResponseError>) => void;
}

export const useConfirmAuthCode = (props?: ConfirmAuthCodeProps) => {
	const mutation = usePoMutation({
		mutationFn: confirmAuthCode,
		onSuccess: (data) => {
			props?.onSuccess?.(data);
		},
		onError: (error) => {
			props?.onError?.(error);
		},
	});

	return mutation;
};
